module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-15.bae6a0e6.png";